import { createFileRoute } from '@tanstack/react-router'
import { BillingPayments } from '../../pages'
import { RoleBasedPlaceholder } from '@/components/organisms/RoleBasedPlaceholder/RoleBasedPlaceholder'

export const Route = createFileRoute('/_layout/billing-and-payments')({
    component: BillingPayments,
    notFoundComponent: () => <RoleBasedPlaceholder />,
})
